export default {
  // Page title
  myLifestyle: 'Min livsstil',
  
  // Page titles and headers
  pageTitle: 'Levnadsvanor',
  subtitle: 'Här ser du vad det handlar om',
  lifestyleTitle: 'Min livsstil',
  lifestyleSubtitle: 'Utvärdera din nuvarande livsstil',
  
  // Section titles
  sections: {
    fitness: 'Fitness',
    food: 'Mat & Näring',
    alcohol: 'Alkohol',
    smoking: 'Rökning',
    sleep: 'Sömn',
    stress: 'Stresshantering',
    social: 'Socialt liv',
    workLifeBalance: 'Arbetslivsbalans'
  },
  
  // Instructions
  instructions: 'Du kan hoppa mellan de olika delarna när du klickat på START.',
  startInstructions: 'Klicka START för att börja livsstilsutvärderingen',
  sectionInstructions: 'Slutför varje sektion för att få en heltäckande bild',
  
  // Button labels
  start: 'Starta',
  next: 'Nästa',
  previous: 'Föregående',
  skip: 'Hoppa över',
  finish: 'Avsluta',
  continue: 'Fortsätt',
  back: 'Tillbaka',
  
  // Loading states
  loadingSections: 'Laddar sektioner...',
  loadingQuestions: 'Hämtar livsstilsfrågor från servern... Detta kan ta några sekunder vid första laddningen.',
  processingAnswers: 'Bearbetar dina svar...',
  savingProgress: 'Sparar din framsteg...',
  
  // Progress indicators
  section: 'Sektion',
  of: 'av',
  question: 'Fråga',
  questions: 'Frågor',
  progress: 'Framsteg',
  
  // Question types
  questionTypes: {
    text: 'Textinmatning',
    multipleChoice: 'Flerval',
    scale: 'Skala',
    yesNo: 'Ja/Nej',
    frequency: 'Frekvens',
    amount: 'Mängd',
    time: 'Tid',
    custom: 'Anpassad'
  },
  
  // Common responses
  responses: {
    yes: 'Ja',
    no: 'Nej',
    sometimes: 'Ibland',
    rarely: 'Sällan',
    often: 'Ofta',
    always: 'Alltid',
    never: 'Aldrig',
    daily: 'Dagligen',
    weekly: 'Veckovis',
    monthly: 'Månadsvis',
    yearly: 'Årligen'
  },
  
  // Error messages
  errorLoading: 'Fel vid laddning av livsstilsfrågor',
  errorSaving: 'Fel vid sparande av dina svar',
  networkError: 'Nätverksfel. Kontrollera din anslutning.',
  serverError: 'Serverfel. Försök igen senare.',
  errorMessages: {
    snackQuestion: 'Du har inte svarat på frågan om dina mellanmål.',
    agilityQuestions: 'Du har inte svarat på alla rörlighetsfrågor.',
    allQuestionParts: 'Du har inte svarat på alla delar av frågan.',
    questionNotAnswered: 'Du har inte svarat på frågan.',
    unansweredQuestions: 'Du har inte svarat på alla frågor ({count} kvar).'
  },
  
  // Success messages
  answersSaved: 'Dina svar har sparats',
  sectionCompleted: 'Sektion slutförd',
  allSectionsCompleted: 'Alla sektioner slutförda!',
  
  // Help text
  help: 'Hjälp',
  tips: 'Tips',
  moreInfo: 'Mer information',
  privacyNote: 'Dina svar är privata och säkra',
  
  // Navigation
  home: 'Hem',
  results: 'Resultat',
  overview: 'Översikt',
  
  // Results
  resultsTitle: 'Dina livsstilsresultat',
  resultsSubtitle: 'Här är vad vi hittade om din livsstil',
  recommendations: 'Rekommendationer',
  improvements: 'Områden för förbättring',
  strengths: 'Dina styrkor',
  showResults: 'Visa resultat',
  goodJobSeeResults: 'Bra jobbat, se resultatet!',
  clickOnPieSlices: 'Klicka på tårtbitarna för att se detaljerat resultat',
  selectAreaForDetails: 'Välj ett område för att se detaljerad information:',
  showDetails: 'Visa detaljer',
  showChart: 'Visa graf',
  notAnswered: 'Inte besvarat',
  unanswered: 'Obesvarad',
  noInformationAvailable: 'Ingen information tillgänglig för detta område',
  
  // Categories
  categories: {
    physical: 'Fysisk hälsa',
    mental: 'Psykisk hälsa',
    social: 'Socialt välbefinnande',
    environmental: 'Miljöfaktorer'
  },
  
  // Health values
  healthValues: {
    riskValue: 'Riskvärde',
    healthValue: 'Friskvärde',
    riskOrHealthValue: 'Risk- eller friskvärde',
    onAlcohol: 'på alkohol',
    riskValueToHealth: '(riskvärde) till 5 för fysisk aktivitet',
    youHaveValue: 'Du har {label}värde',
    risk: 'Risk',
    healthy: 'Frisk',
    warning: 'varnings',
    value: 'Värde'
  },

  // Section introductions
  physicalTestIntro: 'Bra! Nu tar vi några enkla fystester och frågor om din livsstil.',
  fillValueInstruction: '(Fyll i ditt värde och klicka sen på Välj)',
  physicalActivitySummary: 'Sammanfattning Fysisk aktivitet',
  physicalActivityDescription: 'Medelvärde av min kondition, fysiska träning, vardagsaktiviteter, stillasittande.',
  physicalActivityDescriptionNoFitness: 'Medelvärde av fysiska träning, vardagsaktiviteter, stillasittande.',
  physicalTestsSummary: 'Sammanfattning Fysiska tester',
  physicalTestsSummaryDescription: 'Medelvärde av dina svar i fysiska kapacitetstester.',
  kasamSummary: 'Sammanfattning KASAM',
  kasamSummaryDescription: 'Medelvärde av dina svar om känsla av sammanhang.',
  perceivedHealthSummary: 'Sammanfattning Upplevd hälsa',
  perceivedHealthSummaryDescription: 'Medelvärde av dina svar om hur du upplever din hälsa.',
  dependencyAreasSummary: 'Sammanfattning Beroendeområden',
  dependencyAreasDescription: 'Medelvärde av dina svar inom beroendeområden.',
  foodEnergySummary: 'Sammanfattning Mat och energi',
  foodEnergyDescription: 'Medelvärde av dina svar om mat, energi och dryck.',
  leisureLifeSummary: 'Sammanfattning Livet på fritiden',
  leisureLifeDescription: 'Medelvärde av dina svar om fritid, skärmtid och relationer.',
  workLifeArea: 'Arbetsliv',
  workLifeSummary: 'Sammanfattning Arbetsliv',
  workLifeDescription: 'Medelvärde av dina svar om arbetslivet.',
  physicalActivityIntro: 'Nu tar vi några frågor om hur mycket du rör dig.',
  eatingHabitsIntro: 'Nu till dina matvanor.',
  energyBalanceQuestion: 'Äter du för lite eller för mycket i förhållande till hur mycket du rör dig?',
  kasamIntro: 'Nu ett spännande test om du tycker livet känns begripligt, hanterbart och begripligt.',
  notAnsweredOtherQuestions: 'Du har inte svarat på de andra frågorna.',
  clickHereToSee: 'Tryck här för att se',
  clickOnImageToZoom: 'Klicka på bilden för att zooma in på texten',
  dragToMove: 'Dra för att flytta bilden',
  
  // Lifestyle section headers (page labels) - with safe keys
  sectionLabel_kasam: 'Känsla av sammanhang KASAM',
  sectionLabel_physicalTests: 'Fysisk kapacitet - tester',
  sectionLabel_physicalQuestions: 'Fysisk kapacitet frågor',
  sectionLabel_perceivedHealth: 'Upplevd hälsa',
  sectionLabel_dependencies: 'Beroendeområden',
  sectionLabel_foodEnergy: 'Mat och energi',
  sectionLabel_leisureLife: 'Livet på fritiden',
  
  // Legacy sectionLabels (keeping for backwards compatibility)
  sectionLabels: {
    'Känsla av sammanhang KASAM': 'Känsla av sammanhang KASAM',
    'Fysisk kapacitet - tester': 'Fysisk kapacitet - tester',
    'Fysisk kapacitet - frågor': 'Fysisk kapacitet frågor',
    'Upplevd hälsa': 'Upplevd hälsa',
    'Beroendeområden': 'Beroendeområden',
    'Mat och energi': 'Mat och energi',
    'Livet på fritiden': 'Livet på fritiden',
  },
  
  // Lifestyle factor labels (database labels - kept in Swedish)
  factorLabels: {
    // Physical capacity
    'Fysisk kapacitet - frågor': 'Fysisk kapacitet frågor',
    'Fysisk kapacitet - tester': 'Fysisk kapacitet - tester',
    'Min kondition': 'Min kondition',
    'Fysisk träning': 'Fysisk träning',
    'Vardagsaktiviteter': 'Vardagsaktiviteter',
    'Stillasittande': 'Stillasittande',
    'Resultat Fysisk Aktivitet': 'Resultat Fysisk Aktivitet',
    'Balans': 'Balans',
    'Hållning': 'Hållning',
    'Rörlighet': 'Rörlighet',
    'Styrka': 'Styrka',
    'Styrka Ben': 'Styrka Ben',
    'Styrka Armar': 'Styrka arm',
    'Styrka Mage': 'Styrka buk',
    strengthArm: 'Styrka arm',
    strengthCore: 'Styrka buk',
    'Kondition': 'Kondition',
    
    // Nutrition
    'Matvanor': 'Matvanor',
    'Energiintag': 'Energiintag',
    'Energibehov': 'Energibehov',
    'Energibalans': 'Energibalans',
    'Mat och energi': 'Mat och energi',
    'Mina måltidsvanor': 'Mina måltidsvanor',
    'Matinnehåll': 'Matinnehåll',
    'Matmängd': 'Matmängd',
    'Extra energiintag': 'Extra energiintag',
    
    // Dependencies
    'Alkohol': 'Alkohol',
    'Rökning': 'Rökning',
    'Snusning': 'Snusning',
    'Beroendeområden': 'Beroendeområden',
    'Receptfria läkemedel': 'Receptfria läkemedel',
    'Non-prescription medicines': 'Receptfria läkemedel',
    nonPrescriptionMedicines: 'Receptfria läkemedel',
    'Spel om pengar': 'Spel om pengar',
    
    // Health perception
    'Upplevd hälsa': 'Upplevd hälsa',
    'Välmående': 'Välmående',
    'Min kropp': 'Min kropp',
    'Axlar, nacke, rygg': 'Axlar, nacke, rygg',
    'Utvilad': 'Utvilad',
    'Magont': 'Magont',
    'Huvudvärk': 'Huvudvärk',
    'Sömn': 'Sömn',
    'Stress i livet': 'Stress i livet',
    'Stress': 'Stress',
    
    // Leisure
    'Livet på fritiden': 'Livet på fritiden',
    'Fritidsaktiviteter': 'Fritidsaktiviteter',
    'Skärmtid': 'Skärmtid',
    'Vänrelationer': 'Vänrelationer',
    
    // KASAM
    'Känsla av sammanhang KASAM': 'Känsla av sammanhang KASAM',
    'KASAM': 'KASAM',
  },
}; 
